<div class="form-page-wrapper">
  <!-- Body -->
  <div class="container-fluid form-page-placement login-page">
    <div class="row margin-top-m50">
      <app-resume-application></app-resume-application>
    </div>
    
  </div>
</div>
<app-helperlink></app-helperlink>